import { Box } from '@mui/material';
import React from 'react';
import Banner from '../Banner/Banner';
import ContentTabs from '../ContentTabs/ContentTabs';

const Home = () => {
    return (
        <Box>
            <Banner />
            <ContentTabs />
        </Box>
    );
};

export default Home;